<nz-card nzTitle="Search Emails" class="shadow-sm" style="margin-bottom: 16px;">
    <form nz-form [formGroup]="searchForm" (ngSubmit)="onSearch()">
        <div nz-row [nzGutter]="16">
            
            <div nz-col class="gutter-row" [nzSpan]="6">
                <nz-form-item>
                    <nz-form-control>
                        <nz-range-picker formControlName="dateRange" style="width: 100%;"></nz-range-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col class="gutter-row" [nzSpan]="4">
                <nz-form-item>
                    <nz-form-control>
                        <nz-select formControlName="product" nzPlaceHolder="Select Product" nzAllowClear [nzLoading]="isProductsLoading">
                            @for (p of products; track p.id) {
                                <nz-option [nzValue]="p.id" [nzLabel]="p.name!"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col class="gutter-row" [nzSpan]="6">
                <nz-form-item>
                    <nz-form-control>
                        <nz-select formControlName="packages" nzMode="multiple" nzPlaceHolder="Select Packages" nzAllowClear [nzLoading]="isPackagesLoading" [nzDisabled]="!searchForm.get('product')?.value">
                            @for (pkg of packages; track pkg.id) {
                                <nz-option [nzValue]="pkg.id" [nzLabel]="pkg.name!"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col class="gutter-row" [nzSpan]="4">
                <nz-form-item>
                    <nz-form-control>
                        <input nz-input formControlName="customerName" placeholder="Customer Name" />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col class="gutter-row" [nzSpan]="4">
                <nz-form-item>
                    <nz-form-control>
                        <input nz-input formControlName="customerEmail" placeholder="Customer Email" />
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-row>
            <div nz-col [nzSpan]="24" style="text-align: right;">
                <button nz-button nzType="default" type="button" (click)="resetForm()" style="margin-right: 8px;">Reset</button>
                <button nz-button nzType="primary" type="submit">
                    <span nz-icon nzType="search"></span> Search
                </button>
            </div>
        </div>
    </form>
</nz-card>

<nz-card nzTitle="Emails" [nzExtra]="extraTemplate" class="shadow-sm">
    <nz-table #emailTable [nzData]="emails" [nzLoading]="loading" [nzBordered]="true">
        <thead>
            <tr>
                <th>Queue ID</th>
                <th>Sent At</th>
                <th>Customer Name</th>
                <th>Customer Email</th>
				<th>Status</th>
				<th>Error</th>
                <th nzAlign="center">Action</th>
            </tr>
        </thead>
        <tbody>
            @for (email of emailTable.data; track email.id) {
                <tr>
                    <td>{{ email.id }}</td>
                    <td>{{ email.createdAt | date: 'yyyy-MM-dd HH:mm' }}</td>
                    <td>{{ email.customerName }}</td>
                    <td>{{ email.customerEmail }}</td>
					<td>
						@if(email.status === EmailQueueStatusEnum.Complete) {
							<span nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></span> Sent
						} @else if(email.status === EmailQueueStatusEnum.Failed) {
							<span nz-icon nzType="close-circle" nzTheme="twotone" nzTwotoneColor="#ff4d4f"></span> Failed
						}
					</td>
					<td class="text-muted">{{ email.error }}</td>
                    <td nzAlign="center">
                        <button nz-button nzType="primary" nzGhost nzSize="small" 
                            (click)="openDownloadsModal(email)">
                            <span nz-icon nzType="download"></span> View Downloads
                        </button>
                    </td>
                </tr>
            }
        </tbody>
    </nz-table>
</nz-card>

<ng-template #extraTemplate>
    @if (authService.hasAccess(PermissionEnum.EmailCompose)) {
        <button nz-button nzType="primary" (click)="composeEmail()">
            <span nz-icon nzType="plus"></span> Compose Email
        </button>
    }
</ng-template>

<nz-modal [(nzVisible)]="isModalVisible" nzTitle="Download History" (nzOnCancel)="closeModal()" (nzOnOk)="closeModal()" nzWidth="1000px">
    <ng-container *nzModalContent>
        @if (selectedEmail) {
            <div style="margin-bottom: 16px;">
                <strong>Customer:</strong> {{ selectedEmail.customerName }} ({{ selectedEmail.customerEmail }})
            </div>

            <nz-table #downloadsTable [nzData]="selectedDownloads" [nzLoading]="downloadsLoading" [nzShowPagination]="false" nzSize="small" [nzBordered]="true">
                <thead>
                    <tr>
                        <th>Tracker ID</th>
                        <th>Downloaded At</th>
						<th>Expiry</th>
						<th>SDK</th>
						<th>File</th>
                        <th>Reported</th>
                    </tr>
                </thead>
                <tbody>
                    @for (tracker of downloadsTable.data; track tracker.id) {
                        <tr>
                            <td>{{ tracker.id }}</td>
                            <td>{{ tracker.downloadedAt | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
							<td>{{ tracker.downloadToken?.expiresAt| date: 'yyyy-MM-dd HH:mm:ss' }}</td>
							<td>{{ tracker.downloadToken?.sdk?.name }}</td>
							<td>{{ tracker.downloadToken?.driveFile?.driveFileName }}</td>
                            <td>
                                @if(tracker.reported) {
                                    <span nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></span> Yes
                                } @else {
                                    <span nz-icon nzType="close-circle" nzTheme="twotone" nzTwotoneColor="#ff4d4f"></span> No
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </nz-table>
        }
    </ng-container>
</nz-modal>